import { render, staticRenderFns } from "./rotatingProduct.vue?vue&type=template&id=1149871a&scoped=true&"
import script from "./rotatingProduct.vue?vue&type=script&lang=js&"
export * from "./rotatingProduct.vue?vue&type=script&lang=js&"
import style0 from "./rotatingProduct.vue?vue&type=style&index=0&id=1149871a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1149871a",
  null
  
)

export default component.exports